


















import { computed, defineComponent, toRefs } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    amount: {
      type: Number,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    monthMode: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { selected, disabled } = toRefs(props)

    const buttonClasses = computed(() => {
      const c = []
      if (disabled.value) {
        c.push(['tw-opacity-60', 'tw-cursor-not-allowed'])
      }

      if (selected.value) {
        c.push([
          'tw-bg-primary',
          'tw-text-white',
          'tw-border-transparent',
          '!tw-cursor-default'
        ])
      } else {
        if (!disabled.value) {
          c.push('hover:tw-bg-grey-100')
        }
        c.push(['tw-bg-white', 'tw-border-grey-200'])
      }

      return c
    })

    return { buttonClasses }
  }
})
